// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/BrandCompletedDeal/index.css
// module id = 2557
// module chunks = 0